<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LIGMam/images/9781439669280.jpg?1688985130293" alt="This image is the cover for the book Sedona and Oak Creek Canyon, Postcard History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sedona and Oak Creek Canyon, Postcard History Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Most visitors travel to Sedona to view the towering red rock sandstone formations dotted with juniper pines and to hike and explore Oak Creek Canyon, along with other beautiful canyons that were once showcased by the Westerns filmed in Sedona. After the ancient peoples who farmed departed the area, the Homestead Act of the 1870s advertised free land and lured cattle ranchers and farmers, but by the 1960s, tourism reigned, and Sedona became a destination for outdoor activities, art, fine dining, unique shopping, relaxation, and luxury resorts.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Victoria L Clark
      </h2>
      
      <p class="authorDescription body article">Victoria L. Clark is from Tucson, but she retired and moved to Sedona 20 years ago. She began writing and blogging about Arizona's colorful history. She is a former state president of the Arizona Questers, whose members are dedicated to historic preservation and restoration in the United States and Canada. She currently serves on the board of the Sedona Heritage Museum. Collecting historic postcards of Arizona is her passion, and she is a former president of the Phoenix Postcard Club. She has written three books on Arizona's history and one book of short stories.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a92e03c